<template>
  <AppHeader fixed class="flex-nowrap">
    <SidebarToggler class="d-lg-none" display="md" mobile />
    <div
      class="tophrpart d-none d-lg-inline-block"
      v-b-tooltip.hover
      :title="'Version: v' + getVersion"
    >
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-img"
          src="/img/logo.png"
          height="45"
          alt="Connect Logo"
        />
      </b-link>
    </div>
    <SidebarToggler class="d-none" :default-open="true" />

    <b-navbar-nav class="d-flex main-navbarnavitem">
      <slot />
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-button variant="secondary" v-b-tooltip.hover.bottom="'Bulk Actions'" class="mr-1 d-none d-sm-inline-block" @click="showBulkActionsSidebar = true">
        <b-spinner v-if="bulkActionsLoading || bulkActionsActiveCount > 0" small />
        <i v-else class="fa fa-tasks"></i>
        <span v-if="bulkActionsActiveCount > 0" class="badge badge-warning ml-1">{{ bulkActionsActiveCount }}</span>
      </b-button>
      <BulkActionsSidebar
        v-model="showBulkActionsSidebar"
        @update:loading="bulkActionsLoading = $event"
        @update:activeCount="bulkActionsActiveCount = $event"
      />
      <b-button variant="info" v-b-tooltip.hover.bottom="'Open a Ticket'" class="mr-1 d-none d-sm-inline-block" :to="{name: 'Support.NewTickets.Create'}"
      ><i class="fa fa-ticket"></i></b-button>
      <b-button variant="primary" v-b-tooltip.hover.bottom="'Communications Center'" class="mr-1 d-inline-block" @click="getUnreadMessagesCount" :to="{name: 'Communications.Index'}">
        <i class="fa fa-comments-o"></i>
        <span v-if="unreadMessagesCount" class="badge badge-sm badge-danger ml-1">{{ unreadMessagesCount }}</span>
      </b-button>
      <DefaultHeaderDropdownAccnt />
    </b-navbar-nav>
    <div class="asidetoggle-wrap d-none d-lg-block" @click="clickedToggler">
      <AsideToggler />
      <span class="badge badge-danger badge-pill" v-if="unreadCnt > 0">{{
        unreadCnt
      }}</span>
    </div>
  </AppHeader>
</template>
<script>
let refreshTokenTracker = null;
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import BulkActionsSidebar from './BulkActionsSidebar';
import { mapGetters } from 'vuex';

export default {
  name: 'DefaultHeader',
  computed: {
    ...mapGetters(['getVersion', 'getNotifyBusStatus']),
  },
  data() {
    return {
      unreadMessagesCount: 0,
      unreadCnt: 0,
      showBulkActionsSidebar: false,
      bulkActionsLoading: false,
      bulkActionsActiveCount: 0
    };
  },
  mounted() {
    this.loadUnreadCount();
    this.getUnreadMessagesCount();
    clearInterval(refreshTokenTracker);
    refreshTokenTracker = setInterval(() => {
      this.loadUnreadCount();
    }, 120000);
  },
  methods: {
    hookToWebhookChannel() {
      this.$userHub.$on('alerts-count-update', (payload) => {
        this.loadUnreadCount();
      });
      this.$userHub.$on('communications-unreadcount-update', (payload) => {
        this.unreadMessagesCount += payload;
      });
      this.$userHub.$on('CommunicationsRemoveUnreadNum',(ureadToRemove) => {
        setTimeout(() => {
          if(this.unreadMessagesCount > 0){
            this.unreadMessagesCount = this.unreadMessagesCount - ureadToRemove;
          }
          else {
            this.unreadMessagesCount = 0;
          }
        }, 500);
      });
    },
    getUnreadMessagesCount() {
      this.$http
        .get('/api/communications/channels/unreadMessages')
        .then(resp => {
          if(resp.data.unreadCount){
            this.unreadMessagesCount = resp.data.unreadCount;
          }else {
            this.unreadMessagesCount = 0
          }
        })
        .catch(err => {});
    },
    loadUnreadCount() {
      this.$http
        .post('/api/common/notifications/count-unread', {})
        .then(resp => {
          this.unreadCnt = resp.data.unread;
          this.$store.commit('setAlertNumbers', resp.data.alerts);
        })
        .catch(err => {});
      this.$store.dispatch('fetchMyCommonData');
    },
    updateReadAll() {
      this.$http
        .post('/api/common/notifications/update-all-read', {})
        .then(resp => {
          this.unreadCnt = 0;
        })
        .catch(err => {});
    },
    clickedToggler() {
      this.unreadCnt = 0;
      this.updateReadAll();
    }
  },
  watch: {
    getNotifyBusStatus: {
      handler: function(val, oldVal) {
        if(val)
          this.hookToWebhookChannel();
      },
      deep: true
    },
  },
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccnt,
    SidebarToggler,
    BulkActionsSidebar
  }
};
</script>
